import { useNavigate, useParams } from "react-router";
import {
  useDefaultHtzWorkOrderListRequest,
  WorkOrderTable,
  WorkOrderTableFilters,
} from "@/services/backend/htz/work-order/components/work-orders-table";
import { CreateWorkOrderButton } from "@/services/backend/htz/work-order/components/create-work-order-button";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { useState } from "react";
import { DocumentLink } from "@/routes/_components/links/document-link";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function WorkOrderIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(
    useDefaultHtzWorkOrderListRequest(processId!),
  );

  const { data: process } = useProcessesProcessShowQuery({ id: processId! });

  if (!process) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Arbeitsscheine")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Arbeitsscheine")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <WorkOrderTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateWorkOrderButton
                processId={processId!}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <WorkOrderTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={(id, pid, kind) => (
                <DocumentLink
                  documentId={id}
                  documentKind={kind}
                  serviceKind={GSMServiceKind.HTZ}
                  processId={pid}
                />
              )}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
